import React, { useEffect, useState } from "react";
import Util from "../../../Util";
import { useTranslation } from "react-i18next";
import AddNewEnquiry from "./AddNewEnquiry";
import ToastHOC from "../../HOC/ToastHOC";
import ApiCalling from "../../../network/ApiCalling";
import Search from "../../../assets/Icon/Search.svg";
import close from "../../../assets/Icon/close.svg";
import DatePicker from "react-datepicker";
import Calender from "../../../assets/Icon/calendar.svg";
import Select from "react-dropdown-select";
import Sort from "../../../assets/Icon/Short.svg";
import Loader from "../../../components/common/Loader";
import { Avatar } from "@mui/material";
import moment from "moment";
import Stack from "@mui/material/Stack";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Pagination from "@mui/material/Pagination";
import ModalComponent from "../ModalComponent";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Phone from "../../../assets/Icon/Phone.svg";
import Whatsapp from "../../../assets/Icon/whatsapp 1.svg";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Close from "../../../assets/Icon/close.png";
import { getUpdatedSchool } from "../../../components/CommonApis";

const Equiries = (props) => {
  const getLanguage = Util.getSelectedLanguage();
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState({ show: false, isEdit: false });
  const { setIsToast, setIsSubToast } = props;
  const [enquiryList, setEnquiryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [searchClick, setSearchClick] = useState("");
  const [enquiryDate, setEnquiryDate] = useState(null);
  const [followUpDate, setFollowUpDate] = useState(null);
  const [userList, setUserList] = useState([]);
  const [staffId, setStaffId] = useState(0);
  const [enquiryStatusList, setEnquiryStatusList] = useState([]);
  const [statusId, setStatusId] = useState(0);
  const school = Util.getSelectedSchool();
  const [selectedStudentId, setSelectedStudentId] = useState([]);
  const [selectedMultipleStatus, setSelectedMultipleStatus] = useState(null);
  const [openStatusPopup, setOpenStatusPopup] = useState(false);
  const [enquiryData, setEnquiryData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [enquiryInfo, setEnquiryInfo] = useState({});
  const history = useHistory();
  const [gradeId, setGradeId] = useState(0);
  const [gradeList, setGradeList] = useState([]);
  const [roomId, setRoomId] = useState(0);
  const [roomList, setRoomList] = useState([]);
  const [schoolLoading, setSchoolLoading] = useState(true);
  const [isSchool, setIsSchool] = useState(null);

  const getEnquiries = () => {
    if (enquiryDate) {
      const selectedDate = new Date(enquiryDate);
      const utcDate = new Date(
        Date.UTC(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate()
        )
      );
      var enquiryDate1 = utcDate.toISOString().split("T")[0];
    }
    // if (followUpDate) {
    //   const selectedDate = new Date(followUpDate);
    //   const utcDate = new Date(
    //     Date.UTC(
    //       selectedDate.getFullYear(),
    //       selectedDate.getMonth(),
    //       selectedDate.getDate()
    //     )
    //   );
    //   var followUpDate1 = utcDate.toISOString().split("T")[0];
    // }
    setLoading(true);
    const data = {
      page_size: recordPerPage,
      page_number: currentPage,
      follow_up_date:
        followUpDate !== null
          ? moment(followUpDate).format("YYYY-MM-DD HH:mm:ss")
          : null,
      assigned_to: staffId,
      enquiry_status_id: statusId,
      str_search: search,
      inquiry_date: enquiryDate1,
      ascdesc: sortOrder ? "desc" : "asc",
      order_by: sortBy,
      grade_id: gradeId,
      room_id: roomId,
    };
    ApiCalling.apiCallBodyDataPost("student_enquiry/list", data)
      .then((res) => {
        setEnquiryList(res?.data?.data);
        setTotalPages(res.data.totalPages);
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getGradeList = async () => {
    ApiCalling.apiCallBodyDataGet("grade/list")
      .then((res) => {
        setGradeList(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getRoomList = async () => {
    ApiCalling.apiCallBodyDataGet("classroom/list")
      .then((res) => {
        const modifiedClassList = res.data
          .filter((g) => gradeId == 0 || g.Grade.id == gradeId)
          .map((classroom) => ({
            id: classroom.id,
            name: `${classroom.name}`,
          }));
        setRoomList(modifiedClassList);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getEnquiries();
    getStaffList();
    getEnquiryStatusList();
    getGradeList();
    // getRoomList();
  }, []);

  useEffect(() => {
    setRoomId(0);
    getRoomList();
  }, [gradeId]);

  useEffect(() => {
    getEnquiries();
  }, [
    sortBy,
    sortOrder,
    recordPerPage,
    currentPage,
    followUpDate,
    staffId,
    statusId,
    search,
    enquiryDate,
    gradeId,
    roomId,
  ]);

  const handleSort = (field) => {
    setSortBy(field);
    setSortOrder(!sortOrder);
  };

  const handlePreviousClick = () => {
    if (currentPage !== 1) {
      setCurrentPage((currentPage) => currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage !== totalPages) {
      setCurrentPage((currentPage) => currentPage + 1);
    }
  };

  const EnterHandler = (event) => {
    if (event.key === "Enter") {
      setCurrentPage(1);
      setSearchClick(search);
    }
  };

  const searchClicked = () => {
    if (search.length > 0) {
      setSearch("");
      setSearchClick("");
    } else {
      setCurrentPage(1);
      setSearchClick(search);
    }
  };

  const CustomInput = React.forwardRef(
    ({ value, onClick, icon, placeholder, onClear }, ref) => (
      <div className="d-flex" onClick={onClick}>
        <input
          ref={ref}
          className="custom-input__field"
          value={value}
          readOnly
          placeholder={placeholder}
        />
        {value ? null : (
          <div className="custom-input__icon">
            <img src={icon} alt="Calendar" className="svg-icon calender-icon" />
          </div>
        )}

        {value && (
          <div
            className="custom-input__icon"
            onClick={(e) => {
              e.stopPropagation();
              onClear();
            }}
          >
            <img
              src={Close}
              alt="Clear"
              className="svg-icon close-icon"
              width={20}
            />
          </div>
        )}
      </div>
    )
  );

  const handleChangeEnquiryDate = (date) => {
    setEnquiryDate(date);
    setCurrentPage(1);
    // setEnquiryList([]);
  };

  const handleChangeFollowUp = (date) => {
    setFollowUpDate(date);
    setCurrentPage(1);
    // setEnquiryList([]);
  };

  const getStaffList = async () => {
    const data = {
      page_size: 1000,
      page_number: 1,
      role_id: 0,
      str_search: "",
    };
    ApiCalling.apiCallBodyDataPost("user/list", data)
      .then((res) => {
        setUserList(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const changeStaffList = (item) => {
    setCurrentPage(1);
    setStaffId(item[0]?.id);
  };

  const handleChangeStatus = (item) => {
    setStatusId(item[0]?.id);
  };

  const handleChangeGrade = (item) => {
    setGradeId(item[0]?.id);
  };

  const handleChangeRoom = (item) => {
    setRoomId(item[0]?.id);
  };

  const getEnquiryStatusList = () => {
    ApiCalling.apiCallParamsGet("enquiry_status/list")
      .then((res) => {
        setEnquiryStatusList(res?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleAllSelectedStudent = (e) => {
    if (e.target.checked) {
      // setSelectedStudentId(enquiryList.map((item) => item.id));
      setSelectedStudentId(
        enquiryList
          .filter((item) => item?.EnquiryStatus?.references !== "ADMITTED")
          .map((item) => item.id)
      );
    } else {
      setSelectedStudentId([]);
    }
  };

  const handleRowClick = (event) => {
    const id = Number(event.target.value);
    if (event.target.checked) {
      setSelectedStudentId([...selectedStudentId, id]);
    } else {
      const data = selectedStudentId.filter((s) => s !== id);
      setSelectedStudentId(data);
    }
  };

  const changeSelectedMultipleStatus = (data) => {
    setSelectedMultipleStatus(data[0].id);
    setOpenStatusPopup(true);
  };

  const handleConfirmStatus = () => {
    const students = selectedStudentId.join(",");

    const data = {
      user_ids: students,
      enquiry_status_id: selectedMultipleStatus,
    };
    // console.log(selectedMultipleStatus, students);
    // console.log(
    //   enquiryList.filter(
    //     (item) => item?.EnquiryStatus?.references !== "ADMITTED"
    //   )
    // );
    ApiCalling.apiCallBodyDataPost("student_enquiry/update-user-status", data)
      .then((res) => {
        if (res.data.status == true) {
          setIsToast(res.data.message);
          setOpenStatusPopup(false);
          setSelectedStudentId([]);
          setSelectedMultipleStatus();
          getEnquiries();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const navigateToEnrol = () => {
    history.push({
      pathname: "/new-student",
      enquiryData: enquiryInfo,
    });
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Copy Phone Number
    </Tooltip>
  );

  const onCopyText = () => {
    setIsToast("Copied Phone Number");
  };

  useEffect(() => {
    async function fetchData() {
      const schooldata = await getUpdatedSchool(school.id);
      setIsSchool(schooldata);
      setSchoolLoading(false);
    }

    fetchData();
  }, [school.id]);

  if (schoolLoading) {
    return <Loader />;
  }

  if (!isSchool?.enrolment) {
    return (
      <div
        className="d-flex justify-content-center"
        style={{
          fontWeight: "bold",
          fontSize: "20px",
          color: "#ed3131",
          alignItems: "center",
          height: "500px",
        }}
      >
        Module Access Denied
      </div>
    );
  }

  return (
    <>
      <div
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div className="container-fluid">
          <div className="body">
            <div className="col-lg col-md-12 p-3">
              <div className="row py-3">
                <div className="col-md-4 text-start">
                  <h2 className="page-head">{t("Enquiries")}</h2>
                </div>
                <div
                  className={`col-md-8  ${getLanguage !== "ar" && "text-end"}`}
                >
                  {selectedStudentId.length > 0 ? (
                    <div className={"rows-selected dropdown-height"}>
                      <Select
                        searchable={false}
                        className="select-custom text-nowrap dropdown-left"
                        options={[...enquiryStatusList].map((option) => ({
                          ...option,
                          disabled: option.status === "Admitted",
                        }))}
                        onChange={(values) =>
                          changeSelectedMultipleStatus(values)
                        }
                        style={{ width: "100%" }}
                        labelField="status"
                        values={[{ id: 0, status: "Change Status" }]}
                        valueField="id"
                      />
                    </div>
                  ) : (
                    <div className="d-flex justify-content-end align-items-center gap-2">
                      <button
                        // className={`${
                        //   Util.hasPermission("MASTERS_ADD")
                        //     ? "btn primary-sm-btn"
                        //     : "no-permission"
                        // }`}
                        className="btn primary-sm-btn"
                        type="button"
                        onClick={() => {
                          setEnquiryData({});
                          setIsVisible({ show: true, isEdit: false });
                        }}
                      >
                        {t("+ Add New")}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className={"table-div"}>
                <div className="d-flex gap-20 align-items-center table-sort-bar">
                  <div className="">
                    <div className="input-group">
                      <input
                        className="form-control search "
                        placeholder={t("Search Student")}
                        type="text"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                        onKeyPress={(e) => EnterHandler(e)}
                      />
                      <div className="input-group-prepend">
                        <div className="search-icon">
                          <img
                            src={search.length > 0 ? close : Search}
                            className="svg-icon"
                            alt=""
                            onClick={searchClicked}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mr-2">
                    <DatePicker
                      placeholderText="Inquiry Date"
                      selected={enquiryDate}
                      onChange={handleChangeEnquiryDate}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      popperPlacement="bottom"
                      customInput={<CustomInput icon={Calender} />}
                      isClearable={true}
                    />
                  </div>
                  <div className="mr-2">
                    <DatePicker
                      placeholderText="Follow Up Date"
                      selected={followUpDate}
                      onChange={handleChangeFollowUp}
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      popperPlacement="bottom"
                      customInput={<CustomInput icon={Calender} />}
                      isClearable={true}
                    />
                  </div>
                  <div className="mr-2">
                    <Select
                      searchable={false}
                      className="select-custom text-nowrap"
                      options={[
                        { id: 0, label: "Assigned To" },
                        ...userList.map((user) => ({
                          ...user,
                          label: `${user.firstName} ${user.lastName}`,
                        })),
                      ]}
                      onChange={(values) => {
                        changeStaffList(values);
                      }}
                      style={{ width: "100%" }}
                      labelField="label"
                      values={[{ value: "all", label: "Assigned To" }]}
                      valueField="id"
                    />
                  </div>
                  <div className="mr-2">
                    <Select
                      searchable={false}
                      className="select-custom text-nowrap dropdown-left"
                      options={[
                        { id: 0, status: "Status" },
                        ...enquiryStatusList,
                      ]}
                      onChange={(values) => handleChangeStatus(values)}
                      style={{ width: "100%" }}
                      labelField="status"
                      values={[{ id: 0, status: "Status" }]}
                      valueField="id"
                      value={statusId}
                    />
                  </div>
                  <div className="mr-2">
                    <Select
                      searchable={false}
                      className="select-custom text-nowrap dropdown-left"
                      options={[{ id: 0, title: "Grade" }, ...gradeList]}
                      onChange={(values) => handleChangeGrade(values)}
                      style={{ width: "100%" }}
                      labelField="title"
                      values={[{ id: 0, title: "Grade" }]}
                      valueField="id"
                      value={gradeId}
                    />
                  </div>
                  <div className="mr-2">
                    <Select
                      searchable={false}
                      className="select-custom text-nowrap dropdown-left"
                      options={[{ id: 0, name: "Classroom" }, ...roomList]}
                      onChange={(values) => handleChangeRoom(values)}
                      style={{ width: "100%" }}
                      labelField="name"
                      values={[{ id: 0, name: "Classroom" }]}
                      valueField="id"
                      value={roomId}
                    />
                  </div>
                </div>
                {loading ? (
                  <Loader />
                ) : (
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="table-wrapper">
                        <table className="table">
                          <thead>
                            <tr className="text-nowrap">
                              <th
                                scope="col"
                                className="check-col"
                                style={{
                                  paddingRight: "0px",
                                  width: 0,
                                }}
                              >
                                <label className="fancy-checkbox element-left">
                                  <input
                                    type="checkbox"
                                    name="allselect"
                                    onChange={handleAllSelectedStudent}
                                    // checked={
                                    //   enquiryList.length > 0 &&
                                    //   enquiryList.length ===
                                    //     selectedStudentId.length
                                    // }
                                    checked={
                                      enquiryList.length > 0 &&
                                      enquiryList.every(
                                        (item) =>
                                          item?.EnquiryStatus?.references ===
                                            "ADMITTED" ||
                                          selectedStudentId.includes(item.id)
                                      )
                                    }
                                  />
                                  <span></span>
                                </label>
                              </th>
                              <th
                                scope="col"
                                className="check-col"
                                style={{
                                  width: 0,
                                }}
                              >
                                {t("Students Name")}
                                <img
                                  src={Sort}
                                  className="ml-1 fa-sort"
                                  alt=""
                                  onClick={() => {
                                    handleSort(
                                      "student_enquiry.student_first_name"
                                    );
                                  }}
                                />
                              </th>
                              <th
                                scope="col"
                                className="check-col"
                                style={{
                                  width: 0,
                                }}
                              >
                                {t("Primary Contact")}
                                <img
                                  src={Sort}
                                  className="ml-1 fa-sort"
                                  alt=""
                                  onClick={() => {
                                    handleSort(
                                      "student_enquiry.parent_first_name"
                                    );
                                  }}
                                />
                              </th>
                              <th
                                scope="col"
                                className="check-col"
                                style={{
                                  width: 0,
                                }}
                              >
                                {t("Grade")}
                                <img
                                  src={Sort}
                                  className="ml-1 fa-sort"
                                  alt=""
                                  onClick={() => {
                                    handleSort("enquiry_info.grade_id");
                                  }}
                                />
                              </th>
                              <th
                                scope="col"
                                className="check-col"
                                style={{
                                  width: 0,
                                }}
                              >
                                {t("Classroom")}
                                <img
                                  src={Sort}
                                  className="ml-1 fa-sort"
                                  alt=""
                                  onClick={() => {
                                    handleSort("enquiry_info.classroom_id");
                                  }}
                                />
                              </th>
                              <th
                                scope="col"
                                className="check-col"
                                style={{
                                  width: 0,
                                }}
                              >
                                {t("Assigned To")}
                                <img
                                  src={Sort}
                                  className="ml-1 fa-sort"
                                  alt=""
                                  onClick={() => {
                                    handleSort("user.firstName");
                                  }}
                                />
                              </th>
                              <th
                                scope="col"
                                className="check-col"
                                style={{
                                  width: 0,
                                }}
                              >
                                {t("Inquiry Date")}
                                <img
                                  src={Sort}
                                  className="ml-1 fa-sort"
                                  alt=""
                                  onClick={() => {
                                    handleSort("enquiry_info.created_on");
                                  }}
                                />
                              </th>
                              <th
                                scope="col"
                                className="check-col"
                                style={{
                                  width: 0,
                                }}
                              >
                                {t("Follow Up Date")}
                                <img
                                  src={Sort}
                                  className="ml-1 fa-sort"
                                  alt=""
                                  onClick={() => {
                                    handleSort("enquiry_info.follow_up_date");
                                  }}
                                />
                              </th>
                              <th
                                scope="col"
                                className="check-col"
                                style={{
                                  width: 0,
                                }}
                              >
                                {t("Status")}
                                <img
                                  src={Sort}
                                  className="ml-1 fa-sort"
                                  alt=""
                                  onClick={() => {
                                    handleSort(
                                      "enquiry_info.enquiry_status_id"
                                    );
                                  }}
                                />
                              </th>
                            </tr>
                          </thead>
                          {enquiryList?.length > 0 ? (
                            <>
                              <tbody>
                                {enquiryList.map((item, index) => {
                                  return (
                                    <tr
                                      key={item.id}
                                      style={{
                                        backgroundColor: `${
                                          selectedStudentId.includes(item.id)
                                            ? "rgba(100, 24, 195, 0.04)"
                                            : ""
                                        }`,
                                      }}
                                    >
                                      <td
                                        style={{
                                          paddingRight: "0px",
                                          width: 0,
                                        }}
                                      >
                                        <label className="fancy-checkbox element-left">
                                          <input
                                            type="checkbox"
                                            name={item.first_name}
                                            onChange={handleRowClick}
                                            value={item.id}
                                            checked={selectedStudentId.includes(
                                              item.id
                                            )}
                                            disabled={
                                              item?.EnquiryStatus
                                                ?.references === "ADMITTED"
                                            }
                                          />
                                          <span></span>
                                        </label>
                                      </td>
                                      <td
                                        style={{
                                          // paddingLeft: "0px",
                                          width: 0,
                                        }}
                                      >
                                        <div className="d-flex align-items-center">
                                          <Avatar
                                            aria-label="recipe"
                                            className="avatar-font"
                                          >
                                            {item?.StudentEnquiry?.student_first_name.toUpperCase()[0] +
                                              item?.StudentEnquiry?.student_last_name.toUpperCase()[0]}
                                          </Avatar>
                                          <a
                                            className="ml-3"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              setIsVisible({
                                                show: true,
                                                isEdit: true,
                                              });
                                              setEnquiryData(item);
                                            }}
                                          >
                                            {
                                              item?.StudentEnquiry
                                                ?.student_first_name
                                            }{" "}
                                            {
                                              item?.StudentEnquiry
                                                ?.student_last_name
                                            }
                                          </a>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-flex align-items-center">
                                          {
                                            item?.StudentEnquiry
                                              ?.parent_first_name
                                          }{" "}
                                          {
                                            item?.StudentEnquiry
                                              ?.parent_last_name
                                          }
                                          <div className="d-flex justify-content-evenly align-items-center">
                                            <OverlayTrigger
                                              placement="right"
                                              delay={{ show: 250, hide: 400 }}
                                              overlay={renderTooltip}
                                            >
                                              <CopyToClipboard
                                                text={
                                                  item?.StudentEnquiry
                                                    ?.phone_number
                                                }
                                                onCopy={onCopyText}
                                              >
                                                <button className="btn">
                                                  <img
                                                    src={Phone}
                                                    alt="phone"
                                                  />
                                                </button>
                                              </CopyToClipboard>
                                            </OverlayTrigger>
                                            <a
                                              style={{ cursor: "pointer" }}
                                              href={`https://wa.me/${
                                                item?.StudentEnquiry?.phone_number?.startsWith(
                                                  "+"
                                                )
                                                  ? item.StudentEnquiry.phone_number.replace(
                                                      "+",
                                                      ""
                                                    )
                                                  : item.StudentEnquiry
                                                      .phone_number
                                              }`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              <img
                                                src={Whatsapp}
                                                alt="whatsapp"
                                              />
                                            </a>
                                          </div>
                                        </div>
                                        <div>
                                          {item?.StudentEnquiry?.phone_number}
                                        </div>
                                      </td>
                                      <td>
                                        {item?.Grade ? item?.Grade?.title : ""}
                                      </td>
                                      <td>
                                        {item?.ClassRoom
                                          ? item?.ClassRoom?.name
                                          : ""}
                                      </td>
                                      <td>
                                        {item?.User?.firstName
                                          ? item?.User?.firstName +
                                            " " +
                                            item?.User?.lastName
                                          : "-"}
                                      </td>
                                      <td>
                                        {item?.created_on
                                          ? moment(item?.created_on).format(
                                              Util.getMomentDateTimeFormat(
                                                school.date_format
                                              )
                                            )
                                          : "-"}
                                      </td>
                                      <td>
                                        {item?.follow_up_date
                                          ? moment(item?.follow_up_date).format(
                                              Util.getMomentDateTimeFormat(
                                                school.date_format
                                              )
                                            )
                                          : "-"}
                                      </td>
                                      <td>{item?.EnquiryStatus?.status}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </>
                          ) : (
                            <>
                              <tfoot>
                                <tr>
                                  <td colSpan={8}>
                                    {t(
                                      "No Enquiries Found! Please recheck the filter or Create One"
                                    )}
                                  </td>
                                </tr>
                              </tfoot>
                            </>
                          )}
                        </table>
                      </div>
                      {totalPages > 0 && (
                        <div className="row m-0 table-footer border-top">
                          <div
                            className="d-flex justify-content-between align-items-center"
                            style={{ height: "72px" }}
                          >
                            <div className="d-flex align-items-center gap-2">
                              <div className="basic-text">
                                {t("Students Per Page")}
                              </div>
                              <select
                                style={{ width: "72px", cursor: "pointer" }}
                                className="select-dropdown custom-input"
                                value={recordPerPage}
                                onChange={(e) => {
                                  setRecordPerPage(e.target.value);
                                }}
                              >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                              </select>
                            </div>

                            <Stack
                              spacing={2}
                              direction="row"
                              alignItems="center"
                            >
                              <div
                                className={`link-button ${
                                  currentPage == 1 ? "disabled" : ""
                                }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handlePreviousClick();
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <KeyboardArrowLeftIcon />
                                <span className="basic-bold-text">
                                  {t("Previous")}
                                </span>
                              </div>
                              <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={(event, page) => {
                                  setCurrentPage(page);
                                }}
                                size="small"
                                hideNextButton
                                hidePrevButton
                              />
                              <div
                                className={`link-button ${
                                  currentPage == totalPages ? "disabled" : ""
                                }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleNextClick();
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <span className="basic-bold-text">
                                  {t("Next")}
                                </span>
                                <KeyboardArrowRightIcon />
                              </div>
                            </Stack>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <AddNewEnquiry
          show={isVisible.show}
          onClose={() => {
            setIsVisible({ show: false, isEdit: false });
          }}
          onSave={(msg, msg1) => {
            setIsToast(msg);
            setIsSubToast(msg1);
            setIsVisible({ show: false, isEdit: false });
            getEnquiries();
          }}
          enquiryData={enquiryData}
          isEdit={isVisible.isEdit}
          openModal={() => {
            setOpenModal(!openModal);
            setIsVisible({ show: false, isEdit: false });
          }}
          enquiryInfo={(data) => setEnquiryInfo(data)}
        />
        <ModalComponent
          show={openStatusPopup}
          onHide={() => {
            setOpenStatusPopup(false);
            setSelectedStudentId([]);
            setSelectedMultipleStatus();
          }}
          title={t("Change Student status")}
          subTitle={t("Are you sure want to change student status")}
          // size="sm"
          onCancel={t("Cancel")}
          onConfirm={t("Confirm")}
          onCancelClick={() => {
            setOpenStatusPopup(false);
            setSelectedStudentId([]);
            setSelectedMultipleStatus();
          }}
          onConfirmClick={handleConfirmStatus}
        />
        <ModalComponent
          show={openModal}
          onHide={() => {
            setOpenModal(false);
          }}
          title={t("Enrol Student")}
          subTitle={t("Are you sure want to enrol this student?")}
          // size="sm"
          onCancel={t("Cancel")}
          onConfirm={t("Confirm")}
          onCancelClick={() => {
            setOpenModal(false);
          }}
          onConfirmClick={navigateToEnrol}
        />
      </div>
    </>
  );
};

export default ToastHOC(Equiries);
